import { render } from "./SliderLayout.vue?vue&type=template&id=d1932820&scoped=true&ts=true"
import script from "./SliderLayout.vue?vue&type=script&lang=ts"
export * from "./SliderLayout.vue?vue&type=script&lang=ts"

import "./SliderLayout.vue?vue&type=style&index=0&id=d1932820&lang=scss&scoped=true"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1932820"]])

export default __exports__